<template>
    <div v-if="isPausedStatus" ref="automaticProcessingBannerRef">
        <div class="bg-warn-200 p-4 text-center font-bold">
            {{ $t('signalR.automaticProcessingPaused.message') }}
        </div>
    </div>
</template>

<script setup lang="ts">
    import { AutomaticProcessingStatus } from '@/models/automaticProcessingStatus';
    import useSignalRStore from '@/stores/useSignalRStore';
    import { storeToRefs } from 'pinia';
    import { computed } from 'vue';

    const { isAutomaticProcessingPaused: isPaused } = storeToRefs(useSignalRStore());
    const isPausedStatus = computed(() => isPaused.value === AutomaticProcessingStatus.Paused);
</script>
